export class Storage {
	constructor() {}

	setItem(key, value) {
		return localforage.setItem(key, value);
	}

	getItem(key) {
		return localforage.getItem(key);
	}

	removeItem(key) {
		return localforage.removeItem(key);
	}

	clear() {
		return localforage.clear();
	}
}
